<!--常见问题-->
<template>
  <div class="comp-question">
    <!-- 内容区 -->
    <!-- <div class="cont"> -->
    <div class="cont" id="insFaqTop">
        <div class="hd">常见问题</div>
        <div class="bd">
            <div class="pa-ins-faq">
                <dl :class="{'i-current':isCur==0}" >
                    <dt @click="showOrHideDetail(0)"><em>Q1</em><span>哪些慢病人群可以投保本产品？是否需要体检？</span></dt>
                    <dd>本产品共分为糖尿病版、高血压版、甲状腺结节版、其他慢病版4个计划，适用于不同的慢病人群（4个计划的保险责任和价格完全相同，适用的《健康告知》内容存在差异）：<br>
                    <b>糖尿病版</b>：适用于2型糖尿病患者；<br>
                    <b>高血压版：</b>适用于原发性高血压患者；<br>
                    <b>甲状腺结节版：</b>适用于甲状腺结节、甲亢、甲减患者；<br>
                    <b>其他慢病版：</b>适用于高血脂、中轻度脂肪肝、急性支气管炎、急性肺炎、已治愈肺结核、慢性咽炎、胆囊结石、胆囊炎、十二指肠溃疡、痛风、心脏神经官能症、泌尿系统结石、前列腺增生、前列腺囊肿、乳腺囊肿、二级及以下乳腺结节、宫颈炎（宫颈炎合并HPV感染、宫颈上皮内瘤变CIN除外）、阴道炎、盆腔炎、颈椎病、腰椎间盘突出等<a href="javascript:;" data-url="https://m.health.pingan.com/share/page/54/101.pdf" @click="goToThirdPage($event)">《可投保疾病清单》</a>中的其他慢病患者。<br>
                    投保本产品时不要求提交体检报告，但<b>您需要在投保时如实进行健康告知。如果您未如实告知，有可能不能获得赔付。</b></dd>
                  </dl>
                  <dl :class="{'i-current':isCur==1}">
                      <dt @click="showOrHideDetail(1)"><em>Q2</em><span>本产品保什么？慢病既往症是否可以赔？</span></dt>
                      <dd>本产品是针对亚健康及慢病人群设计开发的百万医疗保险， 包含200万一般医疗保险金和200万特定疾病医疗保险金，有无社保均可购买，免赔额2万元。保障范围内，不限社保用药，100%赔付比例；以有基本医疗保险或公费医疗身份投保，但在就诊治疗时未使用基本医疗保险或公费医疗的，赔付比例60%，赔付公式：赔款=（医疗费用-年免赔额）*60%。<br>
                      对于投保时已经确诊、且属于《可投保疾病清单》限制范围内的慢病既往症，保障范围内的医疗费用也可以报销。<br>
                      此外，对于可选附加包：<br>
                      质子重离子医疗附加包：保额100万元，无免赔额，无论是否使用社保报销，赔付比例100%。<br>
                      恶性肿瘤特药附加包：保额150万元，无免赔额，赔付比例100%，已纳入社保目录的药品未使用社保报销的，赔付比例60%，赔付公式：赔款=（医疗费用-年免赔额）*60%。</dd>
                  </dl>
                  <dl :class="{'i-current':isCur==2}">
                      <dt @click="showOrHideDetail(2)"><em>Q3</em><span>门急诊费用可以理赔吗?</span></dt>
                      <dd>保障范围内，办理住院手续前30日内和办理出院手续后30日内，与该次住院相同原因而发生的，必须由被保险人自行承担的门诊急诊医疗费用（包括医生诊疗费、治疗费、检查检验费、药品费、救护车使用费）可以报销。<br>
                      因疾病或意外伤害在医院进行的门诊手术、门诊肾透析，器官移植后的门诊抗排异治疗、门诊恶性肿瘤化疗/放疗/免疫治疗/内分泌治疗/靶向治疗的费用，也可报销。</dd>
                  </dl>
                  <dl :class="{'i-current':isCur==3}">
                      <dt @click="showOrHideDetail(3)"><em>Q4</em><span>在哪些医院治疗可以获得理赔？</span></dt>
                      <dd>在中华人民共和国境内（不含港、澳、台地区）二级以上（含二级）公立医院普通部及约定的医院接受住院、指定门诊、住院前后30天门急诊治疗的，可以报销个人支付的、必要且合理的医疗费用。<br>
                      若您选择了质子重离子附加包，则在上海质子重离子医院，暨复旦大学附属肿瘤医院质子重离子中心，接受质子重离子治疗的，可以报销质子重离子放射治疗而发生的相关费用。</dd>
                  </dl>
                  <dl :class="{'i-current':isCur==4}">
                      <dt @click="showOrHideDetail(4)"><em>Q5</em><span>什么是HelloRun Club？加入HelloRun Club有什么好处？</span></dt>
                      <dd>HelloRun Club是平安健康推出的、以提高会员健康水平为目的的俱乐部，平安健康APP的注册会员均可加入。HelloRun Club会员可通过在平安健康APP完成健康任务获得健康信用。年龄在18周岁-70周岁之间且健康信用达标的HelloRun Club会员，在作为被保险人投保本产品时可根据相应的健康信用调整系数享受优惠费率（优惠幅度最高为30%）。具体优惠规则可见<a href="javascript:;" data-url="https://m.health.pingan.com/share/page/45/101.html" @click="goToThirdPage($event)">《健康信用费率优惠》</a>。</dd>
                  </dl>
              </div>
            <div class="pa-ins-faq-more"><a @click.stop="lookMore()">查看更多</a></div>
          </div>
      </div>
    <!-- </div> -->
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'question',
  data() {
    return {
      name: '常见问题',
      curIndex:0,
      isCur:0
    }
  },
  props: {
  },
  computed: {
    
  },
  methods: {
    showOrHideDetail(index){
      let self = this;
      self.isCur = (self.isCur == index ? -1:index);
    },
    lookMore(){
      this.$router.push({
        name: 'QuestionDetail'
      });
    },
    // 跳转到其他页面
    goToThirdPage(e) {
      let url = e.target.getAttribute('data-url');
      let title = e.target.text || '';
      this.$router.push({
        name: 'ThirdPage',
        query: {
          url: url,
          title: title,
        }
      })
    },
  },
  created() {

  }
}
</script>

<style scoped lang="stylus">
  .comp-question
    width: 100%
    margin-top: .2rem
    .cont
      background: #fff
      .pa-ins-faq-more 
        height: 1.02rem
        text-align: center
        line-height: 1rem
        /*border-bottom: 1px solid #efefef*/
        a 
          font-size: .28rem
          color: #666
          &:after 
            display: inline-block
            width: .14rem
            height: .14rem
            margin-left: .1rem
            content: ''
            vertical-align: 1px;
            border-top: 1px solid #999
            border-right: 1px solid #999
            -webkit-transform: rotate(45deg)
            -moz-transform: rotate(45deg)
            transform: rotate(45deg)
        
      .hd
        /*height: 1.14rem
        line-height: 1.14rem*/
        padding: 0.3rem 0.3rem .1rem
        font-size: .34rem
        font-weight: 500
        color: #333

      .bd 
        padding: 0 .3rem 0 .3rem
        .pa-ins-faq 
          position: relative
          /*margin-top: - .3rem*/
          .i-current
            dt:after
              top: .44rem
              transform: rotate(-45deg)
            dd
              display: block
          dl 
            padding-left: .8rem
            border-bottom: 1px solid #f5f5f5
            dt 
              position: relative
              font-size: .3rem
              color: #333
              &:after 
                position: absolute
                top: .36rem
                display: inline-block
                content: ''
                right: .04rem
                /*display: block*/
                width: .14rem
                height: .14rem
                border-top: 1px solid #999
                border-right: 1px solid #999
                transform: rotate(135deg)
              span 
                display: block
                min-height: .6rem
                padding: .28rem .3rem .28rem 0
                overflow: hidden
              em 
                display: block;
                position: absolute;
                top: .3rem;
                left: -.8rem;
                width: .5rem;
                height: .47rem;
                font-size: .24rem
                line-height: .4rem
                text-align: center;
                color: #fff;
                background: url(../../assets/images/faq_icon.png) no-repeat;
                background-size: cover;
            dd 
              display: none
              padding-bottom: .3rem
              font-size: .28rem
              line-height: .44rem
              color: #666
        
</style>
